import * as Yup from 'yup'

export type ResourceCostDistribution = {
  resourceName: string
  resource: string
  cost: number
}[]

export type CostDistributionFormValues = Partial<{
  provingGround: string
  dateFrom: Date
  dateTo: Date
  generalCostEnabled: boolean
  generalCost: number
  useResourceBooking: boolean
  costDistribution: {
    testTracks: ResourceCostDistribution
    workstations: ResourceCostDistribution
    liftingPlatforms: ResourceCostDistribution
    garages: ResourceCostDistribution
    coldcells: ResourceCostDistribution
    accomodations: ResourceCostDistribution
    radios: ResourceCostDistribution
    fuelCards: ResourceCostDistribution
    accessCards: ResourceCostDistribution
  }
}>

export const CostDistributionFormSchema = Yup.object().shape({
  provingGround: Yup.string().required(),
  dateFrom: Yup.date().required(),
  dateTo: Yup.date().required(),
})
